import { IUnresolvedItemsState } from './unresolvedItems.props';

const initialState: IUnresolvedItemsState = {
  allDismissed: false,
};

export { initialState };
